export default __webpack_public_path__ + "static/newmaterialbox-9a463eb13d17c95224070c890974d574.png";